import React from 'react';
import ReputationCharts from '../../../reputationGraph/ReputationCharts';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "botbit-ui-components";
import './ReputationChartModal.scss';
import translate from "../../../../../config/translations/translate";
import DashboardPeriodSelector from '../../../dashboardPeriodSelector/DashboardPeriodSelector';


const ReputationChartModalComponent = ({store, isOpen, toggle, selectedPeriod, t }) => {
    const TIME_PERIOD_OPTIONS = [
        { value: 'LAST_30_DAYS', label: t('timePeriod.options.LAST_30_DAYS') },
        { value: 'PAST_MONTH', label: t('timePeriod.options.PAST_MONTH') },
        { value: 'LAST_3_MONTHS', label: t('timePeriod.options.LAST_3_MONTHS') },
        { value: 'LAST_6_MONTHS', label: t('timePeriod.options.LAST_6_MONTHS') },
        { value: 'LAST_12_MONTHS', label: t('timePeriod.options.LAST_12_MONTHS') },
        { value: 'THIS_YEAR', label: t('timePeriod.options.THIS_YEAR') }
    ];
    return (
        <div className={isOpen ? "reputation-chart-modal-container" : ""}>
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                   
                    <div className='reputation-chart-modal-header-container'>
                        <h2 className="reputation-chart-modal-header-title">
                            {store ? store.name : t('noStoreSelected')}
                        </h2>
                        <div className='reputation-chart-modal-period-selector-container'>
                            <DashboardPeriodSelector 
                                timePeriodOptions={TIME_PERIOD_OPTIONS}
                                t={t}
                                selectedPeriod={selectedPeriod}
                                handlePeriodChange={()=>{}}
                                readOnly
                            />
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {store && <ReputationCharts storeId={store.id} selectedPeriod={selectedPeriod}/>}
                </ModalBody>
                <ModalFooter>
                    <button className="close-modal-button-reputation-chart-modal" onClick={toggle}>
                        {t('close')}
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

ReputationChartModalComponent.translations = {
    noStoreSelected: {
        es: "No hay tienda seleccionada",
        en: "No store selected"
    },

    close: {
        es: "Cerrar",
        en: "Close"
    },
    timePeriod: {
        label: {
            es: "Período de tiempo",
            en: "Time period",
        },
        options: {
            LAST_7_DAYS: {
            es: "Últimos 7 días",
            en: "Last 7 days",
            },
            LAST_30_DAYS: {
            es: "Últimos 30 días",
            en: "Last 30 days",
            },
            THIS_MONTH: {
            es: "Este mes",
            en: "This month",
            },
            PAST_MONTH: {
              es: "Mes pasado",
              en: "Past month",
            },
            LAST_3_MONTHS: {
            es: "Últimos 3 meses",
            en: "Last 3 months",
            },
            LAST_6_MONTHS: {
            es: "Últimos 6 meses",
            en: "Last 6 months",
            },
            LAST_12_MONTHS: {
            es: "Últimos 12 meses",
            en: "Last 12 months",
            },
            THIS_YEAR: {
            es: "Este año",
            en: "This year",
            },
        }
    },
};

export const ReputationChartModal = translate(ReputationChartModalComponent);